import { getImpersonation, stopImpersonation } from '@/lib/impersonation';

export function ImpersonationBanner() {
  const state = getImpersonation();
  if (!state) return null;
  return (
    <div role="alert" className="sticky top-0 z-50 flex items-center justify-center gap-3 bg-amber-500 px-3 py-1.5 text-sm font-medium text-black">
      <span>Estás viendo Fyso como {state.email} (sesión de superadmin, vence {new Date(state.expiresAt).toLocaleTimeString()}).</span>
      <button type="button" className="rounded border border-black/40 px-2 py-0.5 text-xs hover:bg-black/10" onClick={() => void stopImpersonation()}>
        Salir
      </button>
    </div>
  );
}
